import { ScrollModule } from '@shared/scroll/scroll.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StandFooterComponent } from './stand-footer.component';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';




@NgModule({
    imports: [
    CommonModule,
    RouterModule,
    MatIconModule,
    ScrollModule,
    StandFooterComponent
],
    exports: [
        StandFooterComponent
    ]
})
export class StandFooterModule { }
